import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex items-center px-8 border-b bg-primary-dark" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Skyline ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Log in")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_component = _resolveComponent("icon-component")
  const _component_router_link = _resolveComponent("router-link")
  const _component_search_component = _resolveComponent("search-component")
  const _component_login_button_component = _resolveComponent("login-button-component")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "flex items-center mr-8 text-2xl font-semibold",
      to: "/"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_icon_component, {
          icon: _ctx.Icon.LOGO,
          class: "mr-2"
        }, null, 8, ["icon"]),
        _hoisted_2
      ]),
      _: 1
    }),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navigationLinks, (link, index) => {
      return (_openBlock(), _createBlock("div", {
        key: index,
        class: "self-end mr-8"
      }, [
        _createVNode(_component_router_link, {
          to: link.to
        }, {
          default: _withCtx(({ isActive }) => [
            _createVNode("div", {
              class: ["flex items-center p-4 border-b-4 border-transparent", { 'border-primary': isActive }],
              "data-testid": `navigation-link-${link.label}`
            }, [
              _createVNode(_component_icon_component, {
                icon: link.icon,
                class: "mr-2"
              }, null, 8, ["icon"]),
              _createVNode("div", {
                "data-testid": `navigation-${link.label}`
              }, _toDisplayString(link.label), 9, ["data-testid"])
            ], 10, ["data-testid"])
          ]),
          _: 2
        }, 1032, ["to"])
      ]))
    }), 128)),
    _createVNode(_component_search_component, { class: "mr-2" }),
    _createVNode(_component_login_button_component, {
      class: "ml-auto text-xs",
      isLoggedIn: _ctx.isLoggedIn,
      isEmailVerified: _ctx.isEmailVerified,
      currentUser: _ctx.currentUser
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["isLoggedIn", "isEmailVerified", "currentUser"])
  ]))
}